import React from "react"

const RestaurantSelector = ({ selectedRestaurant, onChange }) => {
  return (
    <>
      <label htmlFor="restaurantName">Restaurant</label>
      <input
        type="text"
        valuename="restaurantName"
        id="restaurantName"
        name="restaurantName"
        onChange={onChange}
        value={selectedRestaurant}
        placeholder="Rechercher un restaurant"
      />
    </>
  )
}

export default RestaurantSelector
